module.exports = __webpack_public_path__ + "static/media/setup-title-background.c8242ec0.jpg";